export default function searchFactory() {
    let factory = this;

    return factory;
}
